import { FormTranslationKey } from '@forto-dev/platform-localisation'

export const FormError = {
  EMAIL: 'email_error',
  MIN_PASSWORD: 'password_min_error',
  MAX_PASSWORD: 'password_max_error',
  PASSWORD_MISMATCH: 'password_mismatch',
} as const satisfies Record<string, FormTranslationKey>
